import { defineProperty as _defineProperty, objectSpread2 as _objectSpread2 } from '../../_virtual/_rollupPluginBabelHelpers.js';
import { THEME_UI_DEFAULT_KEY } from '../../theme-provider/types.esm.js';

var _primary, _neutral, _basic, _THEME_UI_DEFAULT_KEY;
var common = {
  borderRadius: 'pill',
  fontSize: 'xs',
  '> .csg-tui-text': {
    emPaddingX: 'xs'
  },
  '.csg-tui-button': {
    width: 'initial',
    margin: 'initial',
    pr: 'xs',
    '.csg-tui-icon': {
      display: 'initial'
    }
  },
  '.csg-tui-tag': {
    gap: 'unset',
    px: 'unset',
    alignItems: 'baseline'
  }
};
var tagCommon = {
  py: 'xs-3',
  textTransform: 'uppercase',
  color: 'white',
  fontWeight: 'bold',
  fontSize: 'xs-3',
  height: '2em'
};
var tags = (_THEME_UI_DEFAULT_KEY = {}, _defineProperty(_THEME_UI_DEFAULT_KEY, THEME_UI_DEFAULT_KEY, _objectSpread2({
  border: 'neutral',
  bg: 'neutral.subtlest'
}, common)), _defineProperty(_THEME_UI_DEFAULT_KEY, "primary", (_primary = {}, _defineProperty(_primary, THEME_UI_DEFAULT_KEY, _objectSpread2({
  border: 'primary',
  bg: 'primary',
  color: 'white'
}, common)), _defineProperty(_primary, "outline", _objectSpread2({
  variant: "tags.".concat(THEME_UI_DEFAULT_KEY),
  border: 'primary',
  bg: 'primary.light',
  color: 'primary'
}, common)), _primary)), _defineProperty(_THEME_UI_DEFAULT_KEY, "neutral", (_neutral = {}, _defineProperty(_neutral, THEME_UI_DEFAULT_KEY, _objectSpread2({
  border: 'neutral',
  bg: 'neutral.lighter'
}, common)), _defineProperty(_neutral, "outline", _objectSpread2({
  border: 'neutral',
  bg: 'neutral.lighter'
}, common)), _defineProperty(_neutral, "lighter", _objectSpread2(_objectSpread2({
  border: 'neutral',
  bg: 'neutral.lighter'
}, common), {}, {
  '.csg-tui-icon': {
    color: 'primary'
  }
})), _neutral)), _defineProperty(_THEME_UI_DEFAULT_KEY, "basic", (_basic = {}, _defineProperty(_basic, THEME_UI_DEFAULT_KEY, _objectSpread2({
  bg: 'primary.medium'
}, tagCommon)), _defineProperty(_basic, "highlight", _objectSpread2({
  bg: 'highlight18'
}, tagCommon)), _basic)), _THEME_UI_DEFAULT_KEY);

export default tags;
//# sourceMappingURL=tags.esm.js.map
